import theme from '../../themes/index.en'; 

const { palette, spacing, typography } = theme;

const DialogStyles= {
  
  dialogErrorTitle: { 
    color: palette.error.main,
    padding: `${spacing(2)}px ${spacing(3)}px`, 
    fontWeight: 'bold',
    fontSize: typography.h4.fontSize,
  },
  dialogTitle: {
    backgroundColor: palette.primary.light,
    color: palette.common.white,
    borderBottom: `1px solid ${palette.text.primary}`, 
    padding: `${spacing(2)}px ${spacing(3)}px`,
    fontSize: typography.h4.fontSize,
  },
  dialogContentText: {
    // marginTop: spacing(2),
    // marginBottom: spacing(2),
    color: palette.text.primary,
    fontSize: typography.h5.fontSize,
  },
  dialogContentText2: {
    // marginBottom: spacing(2),
    marginTop: spacing(2),
    color: palette.text.primary,
    fontSize: typography.h6.fontSize,
  },
  dialogActions: {
    justifyContent: 'space-between',
    marginTop: spacing(2),
    padding: `${spacing(2)}px ${spacing(3)}px`,
  }, 
  dangerIcon: {
    color: palette.error.main,
    fontSize: 32,
    marginRight: spacing(1),
    marginTop: spacing(2),
    '&:hover': {
      backgroundColor: palette.error.dark,
    },
  },
  cancelDialog: {
    color: palette.text.primary,
    backgroundColor: 'transparent',
    border:`1px solid ${palette.text.primary}`,
    // marginLeft: spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
  resetDialog: {
    color: palette.error.main,
    backgroundColor: 'transparent',
    border:`1px solid ${palette.error.main}`,
    // marginLeft: spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
 
  downloadButton: {
    color: palette.common.white,
    backgroundColor: palette.success.main,
    marginLeft: spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.success.dark,
    },
  },
  importButton: {
    color: palette.common.white,
    backgroundColor: palette.warning.main,
    marginLeft: spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.warning.dark,
    },
  },
  deleteDialog: {
    color: palette.common.white,
    backgroundColor: palette.error.main, 
    marginLeft: spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.error.dark,
    },
  },
  confirmDialog: {
    color: palette.text.secondary,
    background: palette.primary.light, 
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.primary.light
    },
  },
};

export default DialogStyles;
